import script from "./VANTESTING.vue?vue&type=script&setup=true&lang=js"
export * from "./VANTESTING.vue?vue&type=script&setup=true&lang=js"

export default script